<h3>Is this stock correct?</h3>
<h3>Please input the correct stock.</h3>

<h4 class="warning">Do not include trucks in the geofence</h4>
<form [formGroup]="currentStockForm" class="stock-form" (ngSubmit)="sendGhostSandUpdate()">
  <ng-template matStepLabel>Current Stock</ng-template>
  <mat-form-field *ngFor="let storage of storagesInOrder$ | async; trackBy: trackById">
    <input
      sa-number-input
      matInput
      placeholder="{{ storage.mesh.type }} Mesh lbs"
      [formControlName]="storage.id.toString()"
      required
      autocomplete="off"
    />
    <mat-error *ngIf="currentStockForm.get(storage.id.toString()).hasError('required')">
      Input is required
    </mat-error>
    <mat-error *ngIf="currentStockForm.get(storage.id.toString()).hasError('min')">
      Value must be positive number
    </mat-error>
  </mat-form-field>
  <sa-network-active-button class="mt-1" [active]="isNetworkActive$$ | async">
    <button type="submit" mat-raised-button color="primary">
      Reset Current Stock
    </button>
  </sa-network-active-button>
</form>
